import { IGroupIdMetadata, IPrivateEndpointControlMetadata, IPrivateEndpointMetadata } from './private-endpoint-metadata';
import { getReadonlyControl, getManualResourceIdControl } from './shared-control-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { azureResourceSelectMethodOptions } from '../consts/metadata-consts';
import { azurePostgrelSqlDomain } from '../linked-service/azure-postgre-sql-metadata';
import { PrivateEndpointType } from 'shell-models-lib';

const azurePostgreSQLResourceId = '/subscriptions/<subscriptionID>/resourceGroups/<resourceGroupName>/providers/Microsoft.DBforPostgreSQL/<serverType>/<resourceName>';
const azurePostgreSQLSingleServer = 'Microsoft.DBforPostgreSQL/servers';
const azurePostgreSQLFlexibleServer = 'Microsoft.DBforPostgreSQL/flexibleServers';
const azurePostgreSQLHyperscaleServer = 'Microsoft.DBforPostgreSQL/serverGroupsv2';
const azurePostgreSQLResourceIdFormat = '\/?subscriptions\/.+\/resourceGroups\/.+\/providers\/Microsoft.DBforPostgreSQL\/(servers|flexibleServers|serverGroupsv2)\/.+';
const errorMsg = format(stringResources.InvalidResourceId, azurePostgreSQLResourceId);
const resourceTypes = [azurePostgreSQLSingleServer, azurePostgreSQLFlexibleServer, azurePostgreSQLHyperscaleServer];

const metadataControl: IPrivateEndpointControlMetadata = {
    creationControls: [{
        type: 'radio-switch',
        nested: 1,
        label: stringResources.AccountSelectionMethodLabel,
        description: stringResources.AzureSql_SelectMethodDescription,
        options: azureResourceSelectMethodOptions,
        isLabelVertical: true,
        defaultValue: '{privateLinkResourceId != null ? "manual" : "azure"}',
        cases: [
            {
                caseValue: 'azure',
                children: [
                    {
                        type: 'azure-server-database-select',
                        bind: {
                            resourceID: 'privateLinkResourceId',
                            groupID: 'groupId'
                        },
                        resourceTypes,
                        resourceTypeLabels: {
                            servers: stringResources.SingleServer,
                            flexibleServers: stringResources.FlexibleServer,
                            serverGroupsv2: stringResources.Hyperscale
                        },
                        serverDomain: azurePostgrelSqlDomain,
                        isServerSelectOnly: true,
                        validators: {
                            resourceID: [
                                { type: 'required', errorMessage: '' }
                            ]
                        }
                    }
                ]
            },
            {
                caseValue: 'manual',
                children: [
                    getManualResourceIdControl(format(stringResources.PrivateEndpointResourceIdPlaceholder, azurePostgreSQLResourceId), azurePostgreSQLResourceIdFormat, errorMsg)
                ]
            }
        ]
    }],
    readonlyControls: getReadonlyControl(azurePostgreSQLResourceIdFormat, errorMsg)
};

function getGroupIdMetadata(groupId: PrivateEndpointType): IGroupIdMetadata {
    return {
        linkedServiceType: adfModelTypeMap.azurePostgreSQL.linkedServiceType,
        groupId,
        iconClass: 'svg-i-100x100-azure_postgreSQL',
        groupIdFamily: 'postgres',
        displayName: stringResources.AzurePostgreSql_DisplayText
    };
}

export const azurePostgreSQLPrivateEndpointMetadata: IPrivateEndpointMetadata = {
    resourceType: resourceTypes,
    connectionSuffix: {
        [azurePostgreSQLSingleServer]: 'privateEndpoints',
        [azurePostgreSQLFlexibleServer]: 'networking',
        [azurePostgreSQLHyperscaleServer]: 'privateEndpoints'
    },
    resourceIdValidator: azurePostgreSQLResourceIdFormat,
    groupIdMetadata: {
        coordinator: getGroupIdMetadata('coordinator'),
        postgresqlServer: getGroupIdMetadata('postgresqlServer') // default to postgresqlServer
    },
    groupIdFamilyMetadata: {
        postgres: {
            linkedServiceType: adfModelTypeMap.azurePostgreSQL.linkedServiceType,
            displayName: stringResources.AzurePostgreSql_DisplayText,
            iconClass: 'svg-i-100x100-azure_postgreSQL',
            controls: metadataControl
        }
    }
};
